import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'antd';
import { PaginationConfig, ColumnProps } from 'antd/lib/table';

import ModalWrapper from 'src/FBFormComponents/ModalWrapper';
import { $t } from 'src/tools';
import styles from './index.less';

interface IProps {
  loading: boolean;
  source: {
    list: any;
    total: number;
  };
  dispatch: (props: any) => void;
  query: Record<string, number>;
  onChange: (r: Record<string, number>) => {};
}

class ImportHistory extends React.PureComponent<IProps> {
  get columns() {
    return [
      {
        width: '35%',
        title: $t('web_import_time', 'ImportExport'),
        dataIndex: 'time',
      },
      {
        title: $t('web_import_content', 'ImportExport'),
        dataIndex: 'name',
      },
      {
        width: '20%',
        title: $t('operation', 'ImportExport'),
        align: 'center',
        dataIndex: 'status',
        render: (txt: string, record: Record<string, string>) =>
          String(txt) === '2' ? (
            <div className={styles['import-history-active']} onClick={this.handleExport(record)}>
              {$t('download', 'ImportExport')}
            </div>
          ) : (
            <div className={styles['import-history-disabled']}>
              {String(txt) === '3'
                ? $t('web_export_fail', 'ImportExport')
                : $t('web_import_loading', 'ImportExport')}
            </div>
          ),
      },
    ] as ColumnProps<Record<string, string>>[];
  }
  componentDidMount() {
    const { onChange } = this.props;
    onChange && onChange({ page: 1, page_num: 10 });
  }
  render() {
    const { source, loading, query } = this.props;

    return (      
      <Table
        rowKey="id"
        loading={loading}
        columns={this.columns}
        dataSource={source.list}
        onChange={this.handleChange}
        className={styles['import-history-table']}
        pagination={
          source.total <= query.page_num || 10
            ? false
            : {
                size: 'small',
                total: source.total,
                current: query.page,
                showQuickJumper: true,
                pageSize: query.page_num || 10,
              }
        }
      />
    );
  }
  handleExport = (record: Record<string, string>) => {
    return () => {
      const { dispatch } = this.props;
      dispatch({ type: 'down/fetchImportTask', payload: { task_id: record.id } });
    };
  };
  handleChange = (page: PaginationConfig) => {
    const { onChange } = this.props;
    onChange && onChange({ page: page.current || 1, page_num: page.pageSize || 10 });
  };
}

export default ModalWrapper(connect()(ImportHistory));
